// prettier-ignore
module.exports = {
  SITE_KEY: 'at',
  SITE_ORIGIN: 'https://www.apartmenttherapy.com',
  SITE_NAME: 'Apartment Therapy',
  SITE_LOGO: 'SITE_LOGO',
  SITE_TAGLINE: 'Saving the world, one room at a time',
  SITE_ERROR_MESSAGE: 'No amount of washi tape is going to fix this. Maybe we have something else that will do?',
  SITE_FONT: 'playfair',
  LONGTAIL_POST_CUTOFF_ID: 36711902,
  SITE_WIDE_A_B_FLIPS: [],
  PUBLISHER_LOGO: 'https://www.apartmenttherapy.com/static/logos/publisher-logo.png',
  // Categories should be kept in sync with WP, see https://at.apartmenttherapymedia.com/wp-admin/edit-tags.php?taxonomy=category
  // Note, "sponsored" is omitted and is routed to /collection/sponsored in the VCL,
  // and "uncategorized" is not exposed to readers
  CATEGORIES: [
    {
      href: '/categories/show?category=design',
      as: '/design'
    },
    {
      href: '/categories/show?category=house-tours',
      as: '/house-tours'
    },
    {
      href: '/categories/show?category=projects',
      as: '/projects'
    },
    {
      href: '/categories/show?category=organizing-cleaning',
      as: '/organizing-cleaning'
    },
    {
      href: '/categories/show?category=real-estate',
      as: '/real-estate'
    },
    {
      href: '/categories/show?category=life',
      as: '/life'
    },
    {
      href: '/categories/show?category=shop',
      as: '/shop'
    },
    {
      href: '/categories/show?category=news',
      as: '/news'
    }
  ],
  X_SITE: 'https://www.thekitchn.com',
  X_SITE_LOGO: 'X_SITE_LOGO',
  X_SITE_NAME: 'Kitchn',
  X_SITE_DESCRIPTION: 'Kitchn is a source of inspiration for a happier, healthier life in your kitchen.',
  SITE_HEADER: [
    {
      pathPattern: /^\/shop(\/[a-z0-9-_]+)*$/,
      logo: 'RETAIL_THERAPY_LOGO'
    },
    {
      pathPattern: /^\/about(\/[a-z0-9-_]+)*$/,
      logo: 'ATM_SITE_LOGO'
    },
    {
      pathPattern: /^\/search(\/[a-z0-9-_]+)*$/,
      logo: 'SITE_LOGO',
      variant: 'searchPage'
    }
  ],
  TYPE_AHEAD_SEARCH_INDICES: [
    {
      name: 'gen-images',
      id: 'gen-images',
      facetsFilters: [],
      hitsPerPage: 5
    },
    {
      name: 'gen-image-collections',
      id: 'gen-image-collections',
      facetsFilters: [],
      hitsPerPage: 5
    },
    {
      name: 'gen-january-cure-terms',
      id: 'gen-january-cure-terms',
      facetsFilters: [],
      hitsPerPage: 1
    },
    {
      name: 'gen-posts',
      id: 'gen-posts-tours',
      facetsFilters: ['tags:Tours'],
      hitsPerPage: 4
    },
    {
      name: 'gen-posts',
      id: 'gen-posts',
      facetsFilters: ['tags:-Tours'],
      hitsPerPage: 4
    }
  ],
  SEARCH_RESULTS_TABS: [
    { name: 'All', id: 'all', facetFilters: [] },
    {
      name: 'Tours',
      id: 'tours',
      facetFilters: ['tags:Tours']
    },
    {
      name: 'Design',
      id: 'design',
      facetFilters: [
        'tags:Decorating',
        'tags:Interior Design'
      ]
    },
    {
      name: 'Photos',
      id: 'images',
      index: 'gen-images',
      facetFilters: []
    }
  ],
  HIDE_PRISM_TAGS: [
    'weekend-projects',
    'coolest-suburbs',
    'behr-paint',
    'class-of-2020',
    'small-cool-experience-2020',
    'action-hide-image-toolbar'
  ],
  POSTUP_INLINE_MOBILE_IDS: [],
  PLACEHOLDER_IMAGE: 'https://s3.amazonaws.com/pixtruder/original_images/e704e7cb2b618aeb5cd9bd7aaaa5fc977bf0232d',
  SITE_HEADER_FEATURES_HEADING: 'Special Features',
  SPONSORED_HEADER_IMAGES: {
    'gift-edit-2020': {
      url: 'features/gift-edit-2020',
      imageUrl: 'https://cdn.apartmenttherapy.info/image/upload/v1601674411/at/art/design/2020-gift-edit/logo/Gift-guide-edit-at-red.png',
      alt: 'Gift Edit Image Header',
      width: 450,
      height: 106
    }
  },
  SITEMAP_START_DATE: [2010, 1], // year, month
  // Optional site features
  HAS_PRISM: true,
  HAS_GIFT_GUIDE: true,
  HAS_SAVE_IMAGE: true,
  HAS_ADS: true,
  HAS_RECIRC: true,
  HAS_COMMENTS: true,
  HAS_SEARCH: true,
  HAS_ACCOUNT: true,
  HAS_RECIPE_BOX: false,
  HAS_INGREDIENT_ADDON: false,
  HAS_NEWSLETTERS: true,
  HAS_WISH_LISTS: true
};
